// extracted by mini-css-extract-plugin
export default {"cls1":"SocialActionsMenu-cls1__e4f48e47fc1a0ded17ff","cls2":"SocialActionsMenu-cls2___80ae44240ab13ef0728 SocialActionsMenu-cls1__e4f48e47fc1a0ded17ff"};